import PropTypes from 'prop-types';

const defaultProps = {
  lang: null,
};

const propTypes = {
  lang: PropTypes.string,
};

export default function TrainerInfoLanguage({ lang }) {
  const name = getLanguage(lang);

  return (
    <button
      className="inline-flex leading-none px-3 py-1 rounded-full text-xs bg-teal-100 text-teal-900 font-medium focus:outline-none"
      type="button"
    >
      {name}
    </button>
  );
}

function getLanguage(lang) {
  switch (lang) {
    case 'spanish':
      return 'Español';

    case 'english':
      return 'Inglés';

    default:
      return 'Indefinido';
  }
}

TrainerInfoLanguage.defaultProps = defaultProps;
TrainerInfoLanguage.propTypes = propTypes;
